import React from 'react';
import Modal from '.';
import Button from 'components/form/Button';
import {useGlobalAlertModalStore} from 'store/alert';

export default function GlobalAlertModal() {
    const {isOpen, message, close, onConfirm, buttons, title} = useGlobalAlertModalStore();

    if (!isOpen) return null;
    const handleConfirm = () => {
        if (onConfirm) onConfirm();
        close();
    };

    const handleCancel = () => {
        close();
    };
    return (
        <Modal onClose={close} minHeight={'auto'} title={title}>
            {message.length ? (
                <div
                    style={{
                        padding: '24px 0',
                        textAlign: 'center',
                        color: '#222',
                        fontSize: '14px',
                        fontWeight: '500',
                        lineHeight: '18px',
                        letterSpacing: '-0.28px',
                    }}
                >
                    {message.split('\n').map((line, i) => (
                        <React.Fragment key={i}>
                            {line}
                            {i !== message.split('\n').length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </div>
            ) : (
                <div style={{height: '12px'}} />
            )}
            {buttons ? (
                <div style={{display: 'flex', gap: '8px'}}>
                    {buttons.map(({label, method}) => (
                        <Button
                            fillType={method === 'confirm' ? 'fill' : 'outline'}
                            key={label}
                            onClick={method === 'confirm' ? handleConfirm : handleCancel}
                            radius={24}
                            height={48}
                        >
                            {label}
                        </Button>
                    ))}
                </div>
            ) : (
                <Button onClick={handleConfirm} radius={24} height={48}>
                    확인
                </Button>
            )}
        </Modal>
    );
}
